/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PaxCheckRequiredAction {
    PROVIDE_CONSENT_RESPONSE = 'PROVIDE_CONSENT_RESPONSE',
    PROVIDE_NATIONALITY_OR_BIRTHDATE = 'PROVIDE_NATIONALITY_OR_BIRTHDATE',
    PROVIDE_ADDRESS = 'PROVIDE_ADDRESS',
    ANSWER_QUESTIONS = 'ANSWER_QUESTIONS',
    RESOLVE_ITEMS = 'RESOLVE_ITEMS'
}


export function instanceOfPaxCheckRequiredAction(value: any): boolean {
    for (const key in PaxCheckRequiredAction) {
        if (Object.prototype.hasOwnProperty.call(PaxCheckRequiredAction, key)) {
            if (PaxCheckRequiredAction[key as keyof typeof PaxCheckRequiredAction] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PaxCheckRequiredActionFromJSON(json: any): PaxCheckRequiredAction {
    return PaxCheckRequiredActionFromJSONTyped(json, false);
}

export function PaxCheckRequiredActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckRequiredAction {
    return json as PaxCheckRequiredAction;
}

export function PaxCheckRequiredActionToJSON(value?: PaxCheckRequiredAction | null): any {
    return value as any;
}

export function PaxCheckRequiredActionToJSONTyped(value: any, ignoreDiscriminator: boolean): PaxCheckRequiredAction {
    return value as PaxCheckRequiredAction;
}

